import { Notification } from 'src/models';

export class NotificationPagedResult {
    notifications: Notification[];
    totalUnreadNotifications: number;
    totalPages: number;
}
